import api from 'utils/apiClient';

export const getViolations = (params) => {
  return api.get('/moderation_keywords_matches', { params });
};

export const deleteViolation = (id) => {
  return api.post(`/moderation_keywords_matches/${id}/remove_target`);
};